import Vue from 'vue';
import VueGettext from 'vue-gettext';
import translations from '@/translations/translations.json';

Vue.use(VueGettext, {
  availableLanguages: {
    en_US: 'English',
    vi_VN: 'Việt Nam',
    th_TH: 'Thailand',
  },
  defaultLanguage: 'en_US',
  translations: translations,
  silent: true,
});

export default VueGettext;
